import { ConnectedBulkDeviceEditPage } from "fleet/controller/device/connected-bulk-device-edit";
import { ConnectedBulkDeviceRegistrationPage } from "fleet/controller/device/connected-bulk-device-registration";
import { ConnectedConfigureDevicePage } from "fleet/controller/device/connected-configure";
import { ConnectedDeviceView } from "fleet/controller/device/connected-device-view";
import { ConnectedEditDevicePage } from "fleet/controller/device/connected-edit";
import { ConnectedDeviceRegistrationPage } from "fleet/controller/device/connected-new";
import { ConnectedTagViewV2Page } from "fleet/controller/device/connected-tag-view-v2";
import { DeviceFlagsPage } from "fleet/controller/device/device-flags-page";
import { FullDeviceList } from "fleet/controller/device/full-device-list";
import { DeviceDeletePage } from "fleet/view/device/delete-list";
import { DeviceUpgradeFirmwarePage as DeviceUpgradeFirmwarePageV2 } from "fleet/view/device/upgrade-firmware-list-v2";
import { DeviceUpgradeSoftwarePage as DeviceUpgradeSoftwarePageV2 } from "fleet/view/device/upgrade-list-v2";
import React from "react";
import { PrivateRoute } from "ui/private-route";
import { VIEW } from "view/views";

function renderDeviceRoutes() {
  return [
    <PrivateRoute
      exact
      path="/devices"
      key="device-list"
      component={FullDeviceList}
    />,
    <PrivateRoute
      exact
      path="/tags/:id"
      key="device-tag-view"
      component={ConnectedTagViewV2Page}
    />,
    <PrivateRoute
      exact
      path="/devices/:deviceId/flags"
      key="device-flags"
      component={DeviceFlagsPage}
    />,
    <PrivateRoute
      exact
      path={`/devices/${VIEW.CREATE}`}
      key="device-registration"
      component={ConnectedDeviceRegistrationPage}
    />,
    <PrivateRoute
      exact
      path="/devices/bulk-registration"
      key="bulk-device-registration"
      component={ConnectedBulkDeviceRegistrationPage}
    />,
    <PrivateRoute
      exact
      path="/devices/bulk-edit"
      key="bulk-device-edit"
      component={ConnectedBulkDeviceEditPage}
    />,
    <PrivateRoute
      exact
      path="/devices/upgrade"
      key="device-upgrade-downgrade"
      component={DeviceUpgradeSoftwarePageV2}
    />,
    <PrivateRoute
      exact
      path="/devices/upgrade/firmware"
      key="device-upgrade-firmware"
      component={DeviceUpgradeFirmwarePageV2}
    />,
    <PrivateRoute
      exact
      path="/devices/delete"
      key="delete-device"
      component={DeviceDeletePage}
    />,
    <PrivateRoute
      exact
      path="/devices/:deviceId/configure"
      key="device-configure"
      component={ConnectedConfigureDevicePage}
    />,
    <PrivateRoute
      exact
      path={`/devices/:deviceId/${VIEW.EDIT}`}
      key="device-edit"
      component={ConnectedEditDevicePage}
    />,
    <PrivateRoute
      path="/devices/:id/:activeTab?"
      key="device-view::tab"
      component={ConnectedDeviceView}
    />,
  ];
}

export { renderDeviceRoutes };
